import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { U2bValidators } from '@shared/validators/validators';
import { MatDialog } from '@angular/material/dialog';
import { U2bNumericValidators } from '@shared/validators/numeric';
import { BcmVersions } from '@modules/bcm/bcm-versions';
import { BcmTenantType } from '@modules/bcm/@shared/enums/bcm-tenant-type';
import { U2bDateValidators } from '@shared/validators/date/date-validators';
import { addDays, endOfToday } from '@core/date.facade';
import { TranslationService } from '@core/translation/translation.service';

@Component({
    selector: 'form-widget-tenant',
    templateUrl: './form-widget-tenant.component.html',
    standalone: false
})
export class FormWidgetTenantComponent implements OnInit, OnDestroy {

    @Input()
    parentFormGroup: UntypedFormGroup;

    formGroup: UntypedFormGroup;

    BcmVersions = BcmVersions;
    BcmTenantType = BcmTenantType;

    constructor(private _formBuilder: UntypedFormBuilder,
                private _matDialog: MatDialog) {
        this.formGroup = this._formBuilder.group({
            name: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.nameEnterRequired'))]],
            productType: [BcmTenantType.YachtHarbour, [U2bValidators.required(TranslationService.translate('common.validationMsg.selectRequired'))]],
            numberOfBerths: [null, [
                U2bValidators.required(TranslationService.translate('common.validationMsg.berthCountRequired')),
                U2bNumericValidators.integerFormat(),
            ]],
            version: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.versionRequired'))]],
            isDemo: [true],
            addDemoData: [true],
            isDemoUntil: [addDays(endOfToday(), 30), [U2bDateValidators.minDate(new Date())]],
            street: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.streetAndHouseNumberRequired'))]],
            postcode: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.postalCodeRequired'))]],
            city: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.cityEnterRequired'))]],
            country: ['Deutschland', [U2bValidators.required(TranslationService.translate('common.validationMsg.selectCountry'))]],
            mail: [null/*, [U2bValidators.required(TranslationService.translate('common.validationMsg.emailAddressEnterRequired'))]*/],
            phone: [null/*, [U2bValidators.required(TranslationService.translate('common.validationMsg.phoneNumberEnterRequired'))]*/],
            website: [null],
            onlineBookingServiceFeeFlat: [1.5, [U2bNumericValidators.numberMin(0)]],
            onlineBookingServiceFeePercent: [2, [U2bNumericValidators.numberMin(0)]],
        });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.parentFormGroup.addControl('tenant', this.formGroup);
        });
    }

    ngOnDestroy(): void {
        this.parentFormGroup.removeControl('tenant');
    }
}
